module.exports = __webpack_public_path__ + "static/media/knn.63685837.svg";